import { createPopper } from '@popperjs/core';
import { addDelegatedEventListener } from "../utils/delegated-events";
import { getDescribedByElement } from "../utils/element-finders";

export const TOOLTIP_BUTTON_SELECTOR = "[data-tooltip]";

const showTooltip = (element) => {
  if (element.tooltipPopper) return;
  const tooltipElement = getDescribedByElement(element);
  if (!tooltipElement) return;

  tooltipElement.dataset.tooltipVisible = "true";
  element.tooltipPopper = createPopper(element, tooltipElement, {
    placement: "top",
    modifiers: [{ name: "offset", options: { offset: [0, 8] } }],
  });
};

const hideTooltip = (element) => {
  const tooltipElement = getDescribedByElement(element);
  if (!tooltipElement) return;

  tooltipElement.dataset.tooltipVisible = "false";
  element.tooltipPopper?.destroy();
  element.tooltipPopper = null;
};

addDelegatedEventListener(
  document,
  "click",
  TOOLTIP_BUTTON_SELECTOR,
  (event, tooltipButton) => {
    showTooltip(tooltipButton);
    event.preventDefault();
  }
);

addDelegatedEventListener(
  document,
  "mouseover",
  TOOLTIP_BUTTON_SELECTOR,
  (event, tooltipButton) => {
    showTooltip(tooltipButton);
  }
);

addDelegatedEventListener(
  document,
  "mouseout",
  TOOLTIP_BUTTON_SELECTOR,
  (event, tooltipButton) => {
    // Only hide if the tooltip is visible and the mouse isn't moving to a child of the button.
    if (tooltipButton && tooltipButton.tooltipPopper) {
      // Check if we're moving to a child element of the same tooltip button
      const { relatedTarget } = event;
      if (!relatedTarget || !tooltipButton.contains(relatedTarget)) {
        hideTooltip(tooltipButton);
      }
    }
  }
);

addDelegatedEventListener(
  document,
  "focusin",
  TOOLTIP_BUTTON_SELECTOR,
  (event, tooltipButton) => {
    showTooltip(tooltipButton);
  }
);

addDelegatedEventListener(
  document,
  "focusout",
  TOOLTIP_BUTTON_SELECTOR,
  (event, tooltipButton) => {
    hideTooltip(tooltipButton);
  }
);

addDelegatedEventListener(
  document,
  "keyup",
  TOOLTIP_BUTTON_SELECTOR,
  (event, tooltipButton) => {
    if (event.key === "Escape") {
      hideTooltip(tooltipButton);
      event.preventDefault();
    }
  }
);
